import { Address } from 'shopify-types'

import type { AddressFieldsFragment } from '../../__generated/storefront'

export type GQLAddress = AddressFieldsFragment

export const mapGQLAddressToAddress = (address: GQLAddress): Address => ({
  id: address.id,
  firstName: address.firstName ?? '',
  lastName: address.lastName ?? '',
  company: address.company ?? '',
  address1: address.address1 ?? '',
  address2: address.address2 ?? '',
  city: address.city ?? '',
  country: address.country ?? '',
  province: address.province ?? '',
  zip: address.zip ?? '',
  phone: address.phone ?? '',
})
